import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { Auth } from '../../models/auth.model';

@Injectable()
/**
 * Simple class to manage the app auth
 */
export class AuthService {
  /**
   * @ignore
   */
  constructor() {
  }

  /**
   * Method to call the loging service
   * @param authData data to call login service
   */
  public login(authData: Auth): Observable<boolean> {

    // Implementar la logica de autenticacion de la aplicacion aqui.
    return this.dummyLogin(authData);
  }

  /**
   * Dummy implementation to test login  and fail
   */
  dummyLogin(authData: Auth): Observable<boolean> {
    let result = true;
    if (authData.username === 'pepe') {
      result = false;
    }
    sessionStorage.setItem('ACCESS_TOKEN', 'access_token');
    return of(result);
  }

  /**
   * Method to check if the user is logged
   */
  public isLoggedIn(): boolean {

    return sessionStorage.getItem('ACCESS_TOKEN') !== null;

  }

  /**
   * Method to logout the user
   */
  public logout(): void {
    sessionStorage.removeItem('ACCESS_TOKEN');
  }
}
